// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survivor-game-card-container {
  width: 375px;
  height: 130px;
  flex-shrink: 0;
  border-radius: var(--1, 8px);
  border: 0.5px solid #D6D2D2;
  background: #FFF;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 16px;
  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .survivor-game-card-container {
    width: 309.145px;
    height: 101.934px;
  }
}
.survivor-game-card-top-border {
  display: flex;
  width: 100%;
  height: 31px;
  padding: var(--1, 14px);
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-radius: 7px 7px 0px 0px;
  background: #E5E5E5;
}

@media (max-width: 768px) {
  .survivor-game-card-top-border {
    width: 100%;
    height: 25.4px;
  }
}
.survivor-game-card-top-left-text {
  display: flex;
  width: auto;
  height: 15px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #002129;
  font-family: Inter;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal;
  text-align: left;
}

@media (max-width: 768px) {
  .survivor-game-card-top-left-text {
    width: 167px;
    height: 6px;
    font-size: 10px !important;
  }
}
.survivor-game-card-top-right-text {
  display: flex;
  width: 95px;
  height: 15px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #232425;
  text-align: right;
  font-family: Inter;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal;
  text-transform: uppercase;
}

@media (max-width: 768px) {
  .survivor-game-card-top-right-text {
    width: 76px;
    height: 6px;
    font-size: 10px !important;
  }
}
.survivor-game-card-team-row {
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 3px;
}

@media (max-width: 768px) {
  .survivor-game-card-team-row {
    max-width: 288px;
  }
}
.survivor-game-card-logo {
  width: 28px;
  display: block;
  object-fit: contain;
}

@media (max-width: 768px) {
  .survivor-game-card-logo {
    width: 24px;
  }
}
.survivor-game-card-team-name {
  color: #002129;
  text-align: left;
  font-family: Inter;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
  margin-left: 15px;
  width: 250px;
}

@media (max-width: 768px) {
  .survivor-game-card-team-name {
    font-size: 12px !important;
  }
}
.survivor-game-card-button {
  width: 68px;
  height: 27px;
  flex-shrink: 0;
  border-radius: var(--border-radius, 4px);
  background: #E5E5E5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px !important;
}

@media (max-width: 768px) {
  .survivor-game-card-button {
    width: 53px;
    height: 21px;
  }
}
.survivor-game-card-bottom-border {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-top: 1px solid #D6D2D2;
  border-radius: 0px 0px 8px 8px;
  background: #FFF;
  padding: 0 16px;
  height: 25.4px;
}

@media (max-width: 768px) {
  .survivor-game-card-bottom-border {
    padding: 0 13px;
    height: auto;
  }
}
.survivor-game-card-bottom-left-text {
  display: flex;
  width: auto;
  height: 18px;
  margin-top: 6px;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
}

@media (max-width: 768px) {
  .survivor-game-card-bottom-left-text {
    width: 125px;
    height: 18px;
    margin-top: 0;
    font-size: 10px !important;
  }
}
.survivor-game-card-bottom-right-text {
  display: flex;
  width: 175px;
  height: 18px;
  margin-top: 6px;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
}

@media (max-width: 768px) {
  .survivor-game-card-bottom-right-text {
    width: 125px;
    height: 18px;
    margin-top: 0;
    font-size: 10px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SurvivorGames/MyPicks/SurvivorGameCard.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,4CAAA;AACJ;;AAEA;EACI;IACI,gBAAA;IACA,iBAAA;EACN;AACF;AAEA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;;AAGA;EACI;IACI,WAAA;IACA,cAAA;EAAN;AACF;AAGA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AADJ;;AAIA;EACI;IACI,YAAA;IACA,WAAA;IACA,0BAAA;EADN;AACF;AAIA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;AAFJ;;AAKC;EACG;IACI,WAAA;IACA,WAAA;IACA,0BAAA;EAFN;AACF;AAKC;EACG,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAMC;EACG;IACI,gBAAA;EAHN;AACF;AAMC;EACG,WAAA;EACA,cAAA;EACA,mBAAA;AAJJ;;AAOC;EACG;IACI,WAAA;EAJN;AACF;AAOC;EACG,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AALJ;;AAQC;EACG;IACI,0BAAA;EALN;AACF;AAQC;EACG,WAAA;EACA,YAAA;EACA,cAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AANJ;;AASC;EACG;IACI,WAAA;IACA,YAAA;EANN;AACF;AASC;EACG,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,6BAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAPJ;;AAUC;EACG;IACI,eAAA;IACA,YAAA;EAPN;AACF;AAUC;EACG,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AARJ;;AAWC;EACG;IACI,YAAA;IACA,YAAA;IACA,aAAA;IACA,0BAAA;EARN;AACF;AAWC;EACG,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AATJ;;AAYC;EACG;IACI,YAAA;IACA,YAAA;IACA,aAAA;IACA,0BAAA;EATN;AACF","sourcesContent":[".survivor-game-card-container {\n    width: 375px;\n    height: 130px;\n    flex-shrink: 0;\n    border-radius: var(--1, 8px);\n    border: 0.5px solid #D6D2D2;\n    background: #FFF;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    margin-bottom: 16px;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);\n}\n\n@media (max-width: 768px) {\n    .survivor-game-card-container {\n        width: 309.145px;\n        height: 101.934px;\n    }\n}\n\n.survivor-game-card-top-border {\n    display: flex;\n    width: 100%;\n    height: 31px;\n    padding: var(--1, 14px);\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-radius: 7px 7px 0px 0px;\n    background: #E5E5E5;\n}\n\n@media (max-width: 768px) {\n    .survivor-game-card-top-border {\n        width: 100%;\n        height: 25.4px;\n    }\n}\n\n.survivor-game-card-top-left-text {\n    display: flex;\n    width: auto;\n    height: 15px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #002129;\n    font-family: Inter;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: normal;\n    text-align: left;\n}\n\n@media (max-width: 768px) {\n    .survivor-game-card-top-left-text {\n        width: 167px;\n        height: 6px;\n        font-size: 10px !important;\n    }\n}\n\n.survivor-game-card-top-right-text {\n    display: flex;\n    width: 95px;\n    height: 15px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #232425;\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: normal;\n    text-transform: uppercase;\n }\n \n @media (max-width: 768px) {\n    .survivor-game-card-top-right-text {\n        width: 76px;\n        height: 6px;\n        font-size: 10px !important;\n    }\n }\n\n .survivor-game-card-team-row {\n    width: 100%;\n    max-width: 350px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 4px;\n    margin-bottom: 3px;\n }\n \n @media (max-width: 768px) {\n    .survivor-game-card-team-row {\n        max-width: 288px;\n    }\n }\n\n .survivor-game-card-logo {\n    width: 28px;\n    display: block;\n    object-fit: contain;\n }\n\n @media (max-width: 768px) {\n    .survivor-game-card-logo {\n        width: 24px;\n    }\n }\n\n .survivor-game-card-team-name {\n    color: #002129;\n    text-align: left;\n    font-family: Inter;\n    font-size: 14px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: normal;\n    margin-left: 15px;\n    width: 250px;\n }\n \n @media (max-width: 768px) {\n    .survivor-game-card-team-name {\n        font-size: 12px !important;\n    }\n }\n\n .survivor-game-card-button {\n    width: 68px;\n    height: 27px;\n    flex-shrink: 0;\n    border-radius: var(--border-radius, 4px);\n    background: #E5E5E5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px !important;\n }\n \n @media (max-width: 768px) {\n    .survivor-game-card-button {\n        width: 53px;\n        height: 21px;\n    }\n }\n\n .survivor-game-card-bottom-border {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-top: 1px solid #D6D2D2;\n    border-radius: 0px 0px 8px 8px;\n    background: #FFF;\n    padding: 0 16px;\n    height: 25.4px;\n }\n \n @media (max-width: 768px) {\n    .survivor-game-card-bottom-border {\n        padding: 0 13px;\n        height: auto;\n    }\n }\n\n .survivor-game-card-bottom-left-text {\n    display: flex;\n    width: auto;\n    height: 18px;\n    margin-top: 6px;\n    flex-direction: column;\n    justify-content: center;\n    text-align: left;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: normal;\n }\n \n @media (max-width: 768px) {\n    .survivor-game-card-bottom-left-text {\n        width: 125px;\n        height: 18px;\n        margin-top: 0;\n        font-size: 10px !important;\n    }\n }\n\n .survivor-game-card-bottom-right-text {\n    display: flex;\n    width: 175px;\n    height: 18px;\n    margin-top: 6px;\n    flex-direction: column;\n    justify-content: center;\n    text-align: right;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: normal;\n }\n \n @media (max-width: 768px) {\n    .survivor-game-card-bottom-right-text {\n        width: 125px;\n        height: 18px;\n        margin-top: 0;\n        font-size: 10px !important;\n    }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
